import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-incident-list__content"
}
const _hoisted_2 = { class: "as-incident-list__content-data" }

import { computed, PropType, inject, ref, watchEffect, onMounted } from "vue";
import type { IMatch } from "~src/interfaces";
import IBall from "~src/components/icons/incident/IBall.vue";
import IncidentsItem from "./IncidentsItem.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import type { IGoalDetails, IPlayer, ITeam } from "~src/interfaces/footystats";
import { getPlayerLists } from "~src/services/FootystatsService";

const __default__ = {};

interface IProps {
  isHomePage?: boolean;
  goalDetails: IGoalDetails[];
  players: IPlayer[];
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsList',
  props: {
    isHomePage: { type: Boolean, default: false },
    goalDetails: {},
    players: {}
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();

const screenWidth = computed(() => matchDetailStore.getScreenWidth);
const props = __props;

const goals = ref<IGoalDetails[]>(props.goalDetails || []);
// const players = ref<IPlayer[]>([]);

onMounted(async () => {
  if (props.goalDetails) {
    const players = props.players ?? [];
    goals.value = props.goalDetails.map((goal: IGoalDetails) => {
      let player = players.find((p: IPlayer) => p.id === goal.player_id);
      return {
        ...goal,
        player
      };
    });
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-incident-list as-footStats as-d-flex as-flex-column", {
      'as-scrolling as-scrolling__result-popup': !_ctx.isHomePage,
      'as-home-scrollable-content': _ctx.isHomePage,
      'as-incident-list-sm': screenWidth.value < 375,
    }])
  }, [
    (goals.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value, (goal, index) => {
              return (_openBlock(), _createBlock(IncidentsItem, {
                goal: goal,
                modeTeam: goal?.team,
                key: index
              }, null, 8, ["goal", "modeTeam"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})